import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {DashboardComponent} from './components/dashboard/dashboard.component';
import {SubmissionHistoryComponent} from './components/dashboard/submission-history/submission-history.component';
import {SubmissionDetailsComponent} from './components/dashboard/submission-details/submission-details.component';
import {SampleSearchComponent} from './components/dashboard/sample-search/sample-search.component';
import {SampleDetailsComponent} from './components/dashboard/sample-details/sample-details.component';
import {AdminRootComponent} from './components/dashboard/admin-root.component';
import {CreateAnnouncement} from './components/dashboard/admin/announcement/create_announcement/create_announcement.component';
import {AnnouncementPage} from './components/dashboard/admin/announcement/announcement-page/announcement-page.component';
import {ViewAnnouncements} from './components/dashboard/admin/announcement/view_announcements/view_announcements.component';
import {KpiRootComponent} from './components/dashboard/kpi-root.component';
import {KpiComponent} from './components/dashboard/kpi/kpi.component';

const routes: Routes = [
    {
        path: 'admin',
        pathMatch: 'full',
        redirectTo: '/submissions',
    },
    {
        path: 'admin',
        component: AdminRootComponent,
        data: {
            root: 'Admin',
            path: 'admin'
        },
        children: [
            {
                path: '',
                component: AdminRootComponent,
            },
            {
                path: 'announcements/create',
                component: CreateAnnouncement,
                data: {
                    breadcrumb: 'Create New Announcement'
                }
            },
            {
                path: 'announcements/:id',
                component: AnnouncementPage,
                data: {
                    breadcrumb: 'Announcement Details'
                }
            },
            {
                path: 'announcements',
                component: ViewAnnouncements,
                data: {
                    breadcrumb: 'Announcements'
                },

            }
        ]
    },
    {
        path: 'kpi',
        component: KpiRootComponent,
        data: {
            root: 'Kpi',
            path: 'kpi'
        },
        children: [
            {
                path: '',
                component: KpiRootComponent,
            },
            {
                path: 'dashboard',
                component: KpiComponent,
                data: {
                    breadcrumb: 'Create New Announcement'
                }
            }
        ]
    },
    {
        path: 'submissions',
        component: DashboardComponent,
        data: {
            breadcrumb: 'Submissions'
        },
        children: [
            {
                path: '',
                component: SubmissionHistoryComponent,
                data: {
                    breadcrumb: 'none'
                },
            },
            {
                path: 'submission-source/:id',
                component: SubmissionDetailsComponent,
                data: {
                    breadcrumb: 'Submission Source'
                },
            },
            {
                path: 'submission/:id',
                component: SubmissionDetailsComponent,
                data: {
                    breadcrumb: 'Samples'
                },
            },
            {
                path: 'submission/:id/sample/:sampleId',
                component: SampleDetailsComponent,
                data: {
                    breadcrumb: 'Sample Details'
                },
            },
            {
                path: 'sample-search',
                component: SampleSearchComponent,
                data: {
                    breadcrumb: 'Sample Search Results'
                },
            },
            {
                path: '',
                component: SampleSearchComponent,
                data: {
                    breadcrumb: 'none'
                },
            },
        ],
    },
    {
        path: '**',
        redirectTo: '/submissions'
    },
];

@NgModule({
    imports: [ RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' }), RouterModule.forChild(routes) ],
    exports: [ RouterModule ]
})
export class AppRoutingModule {
}
